import React from 'react';

import { ICampaignProps } from '@domain/interfaces/dashboard/AdsManager/Table/Campaign/ICampaign';
import { IOrders } from '@domain/interfaces/dashboard/AdsManager/AdSenseCampaigns/IAdSenseCampaign';

import { useStoreConfig } from '@helpers/hooks/useStoreConfig';
import { useConfig } from '@helpers/hooks/useConfig';

import BlurredContent from './BlurredContent';

import * as S from './styles';

const Orders: React.FC<ICampaignProps> = ({ data, rowData }) => {
  const ordersData: IOrders = data;

  const { store } = useStoreConfig();
  const { isDemoEnvironment } = useConfig();

  const isContentBlurred =
    (!store.is_utm_onboarding_finished || !rowData.has_at_least_one_ads_with_utm_synchronized) &&
    !isDemoEnvironment &&
    !rowData.has_all_ads_with_utm_synchronized;

  return (
    <S.Wrapper>
      {isContentBlurred ? (
        <BlurredContent />
      ) : (
        <>
          <S.ApprovedOrders>{`(${ordersData.paid_quantity}) Aprovados`}</S.ApprovedOrders>
          <S.PendingOrders>{`(${ordersData.pending_quantity}) Pendentes`}</S.PendingOrders>
        </>
      )}
    </S.Wrapper>
  );
};

export default Orders;
